import { render } from "./FilterNumberTag.vue?vue&type=template&id=4a1ba3fa"
import script from "./FilterNumberTag.vue?vue&type=script&lang=js"
export * from "./FilterNumberTag.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__